import React, { forwardRef } from 'react';
import { defineMessage, useIntl } from 'react-intl';
import { CompressIcon, ExpandIcon } from '@panwds/icons';
import { Button } from '../Button/Button.esm.js';
import '@popperjs/core';
import '../Icon/ImgIcon.esm.js';
import '../Icon/SemanticIcons.esm.js';
import '../Button/ProgressButton.esm.js';
import '../Button/CopyButton.esm.js';
import { Tooltip } from '../Tooltip/Tooltip.esm.js';

const expandMessage = defineMessage({ id: "zEQdVX", defaultMessage: [{ type: 0, value: "View in fullscreen mode" }] });
const collapseMessage = defineMessage({ id: "if+Jjj", defaultMessage: [{ type: 0, value: "Exit fullscreen mode" }] });
/**
 * A button to use for entering/exiting fullscreen size to be used in a ModalHeader.
 */
const FullScreenButton = forwardRef(({ isFullScreen, ...passThrough }, ref) => {
    const intl = useIntl();
    const label = intl.formatMessage(isFullScreen ? collapseMessage : expandMessage);
    return (React.createElement(Tooltip, { label: label },
        React.createElement(Button, { "aria-label": label, appearance: "tertiary-clear", size: "sm", isSelected: isFullScreen, icon: isFullScreen ? React.createElement(CompressIcon, { size: "sm" }) : React.createElement(ExpandIcon, { size: "sm" }), ref: ref, ...passThrough })));
});
FullScreenButton.displayName = "FullScreenButton";

export { FullScreenButton };
//# sourceMappingURL=FullScreenButton.esm.js.map
